import Rest from 'services/data/rest';
import axios from 'axios';
import Promise from 'bluebird';

// Actions
import { alerts } from 'modules/alerts/actions';

export default class Search extends Rest {
  static path = 'search';
  static defaultQuery = {};

  static rebuildIndex(type) {
    return Promise.resolve(axios.post('/api/search/index', { type }))
      .tap(response => alerts.success({ title: response.data }))
      .tap(this.logRequest)
      .then((response) => response.data);
  }
}
